import type { Organization, IOrganizationRepository } from '@knownow/domain'
import { ValidationError, normalizeLanguageCode } from '@knownow/domain'

export interface CreateOrganizationInput {
  readonly name: string
  readonly slug: string
  readonly userId: string
  readonly preferredLanguage?: string
}

export class CreateOrganizationUseCase {
  constructor(
    private readonly orgRepo: IOrganizationRepository,
  ) {}

  async execute(input: CreateOrganizationInput): Promise<Organization> {
    const name = input.name.trim()
    const slug = input.slug.trim().toLowerCase()

    if (!name) {
      throw new ValidationError('Organization name must not be empty')
    }
    if (!slug) {
      throw new ValidationError('Organization slug must not be empty')
    }
    if (!/^[a-z0-9][a-z0-9-]*[a-z0-9]$/.test(slug) && slug.length > 1) {
      throw new ValidationError('Slug must contain only lowercase letters, numbers, and hyphens')
    }

    // The repository's create() calls the DB function create_organization_with_owner
    // which atomically creates the org, adds the caller as owner, and sets the
    // default org on their profile. No separate member/profile calls needed.
    return this.orgRepo.create({
      name,
      slug,
      createdBy: input.userId,
      preferredLanguage: normalizeLanguageCode(input.preferredLanguage),
    })
  }
}
